import { viewport } from '@/util/viewport';

// The keyboard's search key (enterkeyhint="search", docs/page-layout.md): on a touch screen it
// closes the keyboard, so the results it covered show; a mouse user keeps the field to type on.
// `field` is an input or a Vuetify field, both of which blur(). Tells whether it closed it.
export const closeKeyboardOnTouch = (field) => {
  if (viewport.canHover) return false;
  field.blur();
  return true;
};
